import * as React from 'react';

import CampaignModulesDataProviderForLohp from 'bundles/campaigns/providers/CampaignModulesDataProviderForLohp';
import FrontPageRedesignQ32025Provider from 'bundles/front-page/providers/FrontPageRedesignQ32025Provider';

const FrontPageDataProvider = ({ children }: React.PropsWithChildren) => {
  return (
    <CampaignModulesDataProviderForLohp>
      <FrontPageRedesignQ32025Provider>{children}</FrontPageRedesignQ32025Provider>
    </CampaignModulesDataProviderForLohp>
  );
};

export default FrontPageDataProvider;
